// DOCS:Enum que sirve para registrar urls globales del sistema
export enum SERVER_URLS {
  // DOCS: Configuración del servidor (APIS E IDENTITY)
  pqNet2ApiDev = 'https://172.24.32.4', // DOCS: URL de la API de desarrollo sin diagonal final
  pqNet2IdentityDev = 'https://172.24.32.4', // DOCS: URL de la API del identity de desarrollo sin diagonal final

  pqNet2ApiDev2 = 'https://172.24.32.5', // DOCS: URL de la API de desarrollo sin diagonal final
  pqNet2IdentityDev2 = 'https://172.24.32.5', // DOCS: URL de la API del identity de desarrollo sin diagonal final

  pqNet2ApiQa = 'https://172.24.34.4', // DOCS: URL de la API de QA sin diagonal final
  pqNet2IdentityQa = 'https://172.24.34.4', // DOCS: URL de la API del identity de QA sin diagonal final

  pqNet2ApiQa2 = 'https://172.24.34.5', // DOCS: URL de la API de QA sin diagonal final
  pqNet2IdentityQa2 = 'https://172.24.34.5', // DOCS: URL de la API del identity de QA sin diagonal final

  pqNet2ApiUat = 'https://172.24.36.4', // DOCS: URL de la API de UAT sin diagonal final
  pqNet2IdentityUat = 'https://172.24.36.4', // DOCS: URL de la API del identity de UAT sin diagonal final

  pqNet2ApiProd = 'https://172.24.20.17', // DOCS: URL de la API de producción sin diagonal final
  pqNet2IdentityProd = 'https://auth.proquifa.com.mx', // DOCS: URL de la API del identity de producción sin diagonal final
}
